import Heading from "common/components/Typography/Heading/Heading";
import React, { useEffect ,useState} from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styles from './EntregaView.module.scss';
import { Button } from "react-bootstrap";
import { Check2Square, ArrowLeft } from "react-bootstrap-icons";
import CargaLibroContableForm from "../../Forms/CargaLibroContableForm/CargaLibroContableForm";
import Axios from 'services/BackendApi/BackendApi';
import Modal from 'react-bootstrap/Modal';

export default function EntregaView(props) {
    const navigate = useNavigate();
    const [name, setName] = useState([]);
    const [count, setCount] = useState([]);
    const [open, setOpen] = useState(true);

    const modalClose = () => setOpen(false);
    function Regresar() {
        navigate("/", true);
    }

    useEffect(() => {
        const pathname = window.location.pathname;
        let array = pathname.split("/");
        let id = array[4];
        getName(id);
    }, []);


    async function getName(id) {
        let res = await Axios.GetNameDelivery({ urlParams: { id } });
        setName(res.data.data[0].code);
        setCount(res.data.data[0].size);
        setOpen(true);
    }


    return <div className={styles.contenedor}>
        <div className={styles.centrar}>
            {/* <Heading variant="h2" override>
                {"Entrega"}
            </Heading> */}
            <Check2Square size={80} color="rgb(39, 39, 39)" />
            <h2>Entrega realizada {name}</h2>
            <br /><br />
            <Button onClick={Regresar} > <ArrowLeft /> Regresar</Button>
        </div>

        <Modal show={open} onHide={modalClose} dialogClassName={styles.alerta}>
            <Modal.Header closeButton className={styles.header}>
                <Modal.Title style={{ color: 'white' }}>Entrega Realizada</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.columna}>
                    <div>
                        <h3>Registros cargados: {count}</h3>
                    </div>

            </Modal.Body>
        </Modal>
    </div>;
}